import(/* webpackMode: "eager" */ "/app/src/app/it-solutions/(truecodepay)/b2c/page.tsx");
